import React from 'react';
import { ReactComponent as QuestionIcon } from '../../assets/icons/question-circle.svg';
import { HelpLinksButton, HelpLinksWrapper } from './Theme';

const HelpLinks = () => {

  return (
    <HelpLinksWrapper variant="contained" >
      <HelpLinksButton href='https://46220420.hs-sites.com/' target="_blank">
         <QuestionIcon width={20}/>
      </HelpLinksButton>
    </HelpLinksWrapper>
  )
}

export default HelpLinks